export default {
  grades: [],
};
